<ng-container *ngIf="showClose">
  <button class="close" type="button" (click)="onClickClose()"><i class="icon-cerrar close__icon"></i></button>
</ng-container>
<div class="tag tag--{{ color }} tag--{{ radius }}" (click)="onClickTag($event)" (keydown.enter)="onClickTag($event)">
  <span class="tag__content">
    <ng-content></ng-content>
  </span>
</div>
